export const BACKGROUND_IMAGE_DEFAULT_COORDINATES = [
    {
        lat: 64.752563010893,
        lng: 6.348806828213952
    },
    {
        lat: 64.752563010893,
        lng: 26.492939132575827
    },
    {
        lat: 54.80175295315382,
        lng: 26.492939132575827
    },
    {
        lat: 54.80175295315382,
        lng: 6.348806828213952
    }
];
